export const COMPONENT_SOURCE_TYPES = {
  "0": { label: "ACU", value: 0, isDisabled: false },
  "GENERIC": { label: "GENERIC", value: 1, isDisabled: false },
  "187": { label: "IEX-16", value: "IEX_16", isDisabled: false },
  "186": { label: "REX-16 ", value: "REX_16 ", isDisabled: false },
}